export default __webpack_public_path__ + "static/DSC_0452-9abac36a3479eda3f320852720ebd0a3.jpg";